module.exports = __webpack_public_path__ + "static/media/content-6.0c90c72a.svg";